import { DeviceRepository } from '@telespot/domain';

export interface ICountDevicesByDeviceTypeQuery {
  /**
   * Counts how many devices reference the given device type. Repository errors
   * propagate so the caller can update its error state.
   */
  execute(deviceTypeId: string): Promise<number>;
}

export class CountDevicesByDeviceTypeQuery implements ICountDevicesByDeviceTypeQuery {
  constructor(private readonly deviceRepository: DeviceRepository) {}

  public async execute(deviceTypeId: string): Promise<number> {
    return this.deviceRepository.countByDeviceType(deviceTypeId);
  }
}
